var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"common-diagonal-placeholder",attrs:{"viewBox":"0 0 1 1","preserveAspectRatio":"none"}},[_c('path',{staticClass:"common-diagonal-placeholder__line",attrs:{"d":"M0,0 L0,0 1,1"}})])}
var staticRenderFns = []

export { render, staticRenderFns }